var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentXNameWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1869_20405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9346 94.749H48.8164C54.5794 94.749 59.251 99.4206 59.251 105.184V137.065C59.2508 142.828 54.5793 147.5 48.8164 147.5H16.9346C11.1718 147.5 6.50016 142.828 6.5 137.065V105.184C6.5 99.4207 11.1717 94.7491 16.9346 94.749ZM15.627 6.5H43.7061C46.6558 6.5 49.2724 7.90568 50.9395 10.0752L50.959 10.1016L50.9824 10.124L95.1328 54.2744C96.1875 56.2125 97.7866 57.8113 99.7246 58.8662L143.876 103.018L143.898 103.041L143.925 103.061C146.094 104.728 147.5 107.344 147.5 110.294V138.373C147.5 143.416 143.416 147.5 138.373 147.5H110.294C107.968 147.5 105.854 146.619 104.239 145.188L103.888 144.875L103.876 144.886L59.0273 100.038C57.9249 97.8546 56.1446 96.0739 53.9609 94.9717L9.91602 50.9258L9.96973 50.873L9.57324 50.5215C7.69214 48.846 6.5 46.4195 6.5 43.7061V15.627C6.50009 10.5842 10.5842 6.50009 15.627 6.5ZM105.184 6.5H137.065C142.828 6.50016 147.5 11.1718 147.5 16.9346V48.8164C147.5 54.5793 142.828 59.2508 137.065 59.251H105.184C99.4206 59.251 94.749 54.5794 94.749 48.8164V16.9346C94.7491 11.1717 99.4207 6.5 105.184 6.5Z",
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8166 94.2485H16.9348C10.8957 94.2485 6 99.1442 6 105.183V137.065C6 143.104 10.8957 148 16.9348 148H48.8166C54.8557 148 59.7514 143.104 59.7514 137.065V105.183C59.7514 99.1442 54.8557 94.2485 48.8166 94.2485Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.065 6H105.183C99.1442 6 94.2485 10.8957 94.2485 16.9348V48.8166C94.2485 54.8557 99.1442 59.7514 105.183 59.7514H137.065C143.104 59.7514 148 54.8557 148 48.8166V16.9348C148 10.8957 143.104 6 137.065 6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.229 102.664L51.3357 9.77062C49.5788 7.48418 46.819 6 43.7062 6H15.6271C10.3081 6 6 10.3081 6 15.6271V43.7062C6 46.5703 7.25955 49.1295 9.24113 50.8945L9.20904 50.9266L103.876 145.593L103.908 145.561C105.609 147.069 107.839 148 110.294 148H138.373C143.692 148 148 143.692 148 138.373V110.294C148 107.181 146.516 104.421 144.229 102.664Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1869_20405",
    x: 0.5,
    y: 0.5,
    width: 153,
    height: 153,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.75,
    result: "effect1_foregroundBlur_1869_20405"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentXNameWhite);
export default __webpack_public_path__ + "static/media/IdentXNameWhite.f56b23bc918ac046d138a8a555e4b3f6.svg";
export { ForwardRef as ReactComponent };